import { render, staticRenderFns } from "./template.vue?vue&type=template&id=882a76ae&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=882a76ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882a76ae",
  null
  
)

export default component.exports